import React from 'react';
import { useMap } from 'react-leaflet';
import './ZoomButtons.css';

/**
 * ZoomButtons Component
 * Provides zoom in/out controls for the Leaflet map
 */
function ZoomButtons() {
  const map = useMap();

  const handleZoomIn = () => {
    map.zoomIn();
  };

  const handleZoomOut = () => {
    map.zoomOut();
  };

  return (
    <div className="zoom-buttons">
      <button
        onClick={handleZoomIn}
        title="Zoom in"
        className="zoom-button zoom-button-in"
        aria-label="Zoom in"
      >
        +
      </button>
      <button
        onClick={handleZoomOut}
        title="Zoom out"
        className="zoom-button zoom-button-out"
        aria-label="Zoom out"
      >
        -
      </button>
    </div>
  );
}

export default ZoomButtons;
